/**
 * A dose the backend says is not due yet.
 *
 * All of the logic lives server-side: the backend decides what counts as early
 * and writes the entire dialog - title, message, detail lines, button captions -
 * into dose_gap_prompt. This file only picks the prompt to show. There is
 * deliberately no threshold, no clock arithmetic and no wording here, so the
 * rule cannot drift between the Driver app, the In-Store app and the server.
 *
 * The backend re-checks on submit, so this is the prompt, not the guard.
 */
export const resolveDoseGapBlock = (selectedDoses) => {
    const doses = Array.isArray(selectedDoses)
        ? selectedDoses
        : Object.values(selectedDoses || {}).flat();

    const blocked = doses
        .filter((dose) => dose?.dose_gap_prompt?.requires_confirmation)
        .map((dose) => dose.dose_gap_prompt);

    if (blocked.length === 0) return null;

    // The tightest one: that is the dose the dialog has to describe.
    return blocked.reduce((worst, prompt) => (
        Number(prompt?.shortfall_minutes || 0) > Number(worst?.shortfall_minutes || 0) ? prompt : worst
    ), blocked[0]);
};
